@let pickupSelectors = this.forDependent ? this.dependentReadyForPickupSelectors : this.readyForPickupSelectors;

@if (isCard) {
  <mat-card>
    <mat-card-title class="pb-0 text-headline-small md:text-headline-medium">Ready for Pickup ({{ pickupSelectors.totalCount | select }})</mat-card-title>

    <mat-card-content class="pt-0">
      <ng-container *ngTemplateOutlet="pickups"/>
    </mat-card-content>
  </mat-card>
} @else {
  <ng-container *ngTemplateOutlet="pickups"/>
}


<ng-template #pickups>
  <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -- We are using inline styles for animation purposes. -->
  <div #itemsContainer class="overflow-hidden transition-[height]" [style.height]="itemsContainerHeight">
    @for (group of pickupSelectors.groups | select:[]; track group.branchId) {
      <div class="flex flex-col gap-y-3 py-3" [class.pt-0]="$first">
        <p class="text-title-medium md:text-title-large">{{ group.itemCount }} at {{ branchesSelectors.branchNameForId(group.branchId) | select }}</p>

        <px-cover-image-grid [catalogRecords]="minimalCatalogRecordsFor(group.holds)" class="md:py-3">
          <ng-template #catalogRecordInfo let-hold="extraData">
            <div class="flex flex-col justify-start items-center gap-y-3">
              <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -- We are using inline styles for animation purposes. -->
              <div class="overflow-hidden transition-[max-height]" [style.maxHeight]="titlesAreExpanded ? '2lh' : '0'">
                <p mxTruncate [mxTruncateMaxLines]="2" class="text-label-large text-center min-h-[2lh]">{{ hold.itemTitle }}</p>
              </div>

              <div class="flex flex-col justify-start items-center">
                <p class="text-body-small">Pick up by</p>
                <p class="text-title-medium">{{ hold.pickupExpireDate | format:'LONG_DATE_MONTH_ORDINAL_DAY_ONLY' }}</p>
              </div>
            </div>
          </ng-template>
        </px-cover-image-grid>
      </div>
    }
  </div>

  <mx-action-buttons>
    <px-see-more-less-button [expanded]="itemsAreExpanded" [enabled]="enableExpansionToggleButton" (click)="onClickExpansionToggleButton()"/>
  </mx-action-buttons>
</ng-template>
